// eslint-disable-next-line import/no-extraneous-dependencies
import Qs from 'qs'
import { catchError } from '../../utils/CatchError/CatchError'
import { apiService } from '../_config_/apiservice'

export const getTabelaVendas = async (
  cancel: any,
  id: number,
  tela: string,
  page: number
): Promise<GetSalesType | { message: string }> => {
  try {
    const result = await apiService.get(`app/venda/${tela}/${id}`, {
      cancelToken: cancel.token,
      params: {
        page: page - 1,
        size: 7,
      },
      paramsSerializer(paramsAux: any) {
        return Qs.stringify(paramsAux, { arrayFormat: 'repeat' })
      },
    })
    if (result.status === 200) {
      return result.data
    }
  } catch (error) {
    return catchError(error)
  }
  return {
    message: 'Algo de errado aconteceu!',
  }
}
